import Box from '@/components/UI/box/Box';
import styles from './PriceRangeContainer.module.scss';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import Button from '@/components/UI/button/Button';
import PriceSlider from './priceSlider/PriceSlider';
import { PriceRangeData } from '../MidTermPriceRange';
import { Control, SubmitHandler, UseFormHandleSubmit } from 'react-hook-form';
import { FC } from 'react';
interface Props {
  handleClose: () => void;
  handleSubmit: UseFormHandleSubmit<PriceRangeData>;
  onSubmit: SubmitHandler<PriceRangeData>;
  handleResetFilter: (e: any) => void;
  control: Control<PriceRangeData>;
}
const PriceRangeContainer: FC<Props> = ({
  handleClose,
  handleSubmit,
  onSubmit,
  handleResetFilter,
  control
}) => {
  return <Box className={styles['midterm-price-range-container']} data-sentry-element="Box" data-sentry-component="PriceRangeContainer" data-sentry-source-file="PriceRangeContainer.tsx">
      <Box className={styles['price-range-header']} data-sentry-element="Box" data-sentry-source-file="PriceRangeContainer.tsx">
        <Box onClick={handleClose} className={styles['close-icon-section']} data-sentry-element="Box" data-sentry-source-file="PriceRangeContainer.tsx">
          <Icon name="close" type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="PriceRangeContainer.tsx" />
        </Box>
        <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="PriceRangeContainer.tsx">محدوده قیمت</Typography>
      </Box>
      <form id="hook-form" className={styles['price-range-form-container']} onSubmit={handleSubmit(onSubmit)}>
        <Box className={styles['midterm-price-range-section']} data-sentry-element="Box" data-sentry-source-file="PriceRangeContainer.tsx">
          <Typography variant="bodyL" color="neutral_800" data-sentry-element="Typography" data-sentry-source-file="PriceRangeContainer.tsx">
            بازه قیمت ماهانه را مشخص کنید.
          </Typography>
          <PriceSlider control={control} data-sentry-element="PriceSlider" data-sentry-source-file="PriceRangeContainer.tsx" />
        </Box>
        <Box className={styles['action-footer']} data-sentry-element="Box" data-sentry-source-file="PriceRangeContainer.tsx">
          <Button format="outlined" onClick={handleResetFilter} data-sentry-element="Button" data-sentry-source-file="PriceRangeContainer.tsx">
            پاک کردن{' '}
          </Button>

          <Button format="primary" size="medium" type="submit" data-sentry-element="Button" data-sentry-source-file="PriceRangeContainer.tsx">
            اعمال بازه قیمتی
          </Button>
        </Box>
      </form>
    </Box>;
};
export default PriceRangeContainer;